define('lq/events/actions/calendarEventsExportCommand',[
    'lq',
    'lq/events/actions/eventAction'
], function (lq,EventAction) {
    'use strict';

    function CalendarEventsExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CalendarEventsExportCommand, EventAction);

    CalendarEventsExportCommand.typeName = 'CalendarEventsExportCommand';

    CalendarEventsExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CalendarEventsExportCommand.prototype.createEventActionRequest = function () {
        if (this.eventData.downloadOnly)
            return undefined;

        return {
            eventActionType: 'CalendarEventsExport',
            command: this.eventData.command
        };
    };

    CalendarEventsExportCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.downloadOnly) {
            var queryString = {
                actionId: this.piping.actionId,
                calendarExportId: this.eventData.command,
                parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters() || {})
            };
            var url = this.piping.url.prepare(lq.getTenantUrl('Export/CalendarEvent'), queryString);
            window.location.href = url + '#toolbar=1';
            continuation();
        } else if (eventActionResponse.Download) {
            var queryString = {
                url: eventActionResponse.Url,
                filename: eventActionResponse.Filename,
                openInBrowser: false
            };
            window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), queryString);
            continuation();
        } else {
            continuation();
        }
    };

    return CalendarEventsExportCommand;
});
